export const task = {
    'TASKLISTS': 'task/TASKLISTS', // 任务列表
    'USERINFO': 'task/USERINFO', // 用户信息
    'TYPELISTS': 'task/TYPELISTS', // 任务类型列表
    'HELPLISTS': 'task/HELPLISTS', // 帮助类型列表
    'HELPINFO': 'task/HELPINFO', // 帮助信息
    'LAYER': 'task/LAYER', // 打开任务介绍弹层
    'EXPERIENCE': 'task/EXPERIENCE', // 经验
    'SET_EXPER': 'task/SET_EXPER', // 经验
    'TASKLISTS_BY_TYPE': 'task/TASKLISTS_BY_TYPE', // 获取任务信息通过tab切换
    'CHESTLIST': 'task/CHESTLIST', // 宝箱数据
    'ALLCOMPLETE': 'task/ALLCOMPLETE', // 新手任务全部完成标记
    'TREASURELEVEL': 'task/TREASURELEVEL', // 打开宝箱 和 打开之后的奖励信息
    'ADDS': 'task/ADDS', // 新手礼包
    'EXPERLAYER': 'task/EXPERLAYER' // 经验动画
}

export const about = {
    'LINK_LIST': 'about/LINK_LIST', // 链接列表
    'CLIENT_INFO': 'about/CLIENT_INFO', // cookie信息
    'QUES_LIST': 'about/GETQUES_LIST_DATA' // 问题列表
}

export const fdback = {
    'CLIENT_INFO': 'fdback/CLIENT_INFO', // cookie信息
    'FDBACK_LIST': 'fdback/FDBACK_LIST', // 问题与反馈列表
    'FDBACK_LISTS': 'fdback/FDBACK_LISTS', // 问题与反馈列表
    'FDBA_LIST': 'fdback/FDBA_LIST' // 问题与反馈列表
}

export const stufdback = {
    'CLIENT_INFO': 'stufdback/CLIENT_INFO', // cookie信息
    'FDBACK_LIST': 'stufdback/FDBACK_LIST', // 问题与反馈列表
    'FDBACK_LISTS': 'stufdback/FDBACK_LISTS', // 问题与反馈列表
    'FDBA_LIST': 'stufdback/FDBA_LIST' // 问题与反馈列表
}

export const GLOBAL = {
    'ENV': 'global/ENVIRONMENT'
}

export default {}



// WEBPACK FOOTER //
// ./src/store/mutation-type.js